var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitchUnchecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    fill: "#C7C7C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.63775 2.94543L5.18338 4.39994L6.63775 5.85439C6.85408 6.07081 6.85408 6.42137 6.63775 6.63778C6.52966 6.74587 6.38795 6.79995 6.2463 6.79995C6.10443 6.79995 5.9627 6.74595 5.85469 6.63778L4.40001 5.18316L2.94543 6.63776C2.83735 6.74585 2.69563 6.79994 2.55386 6.79994C2.41213 6.79994 2.2705 6.74594 2.16233 6.63776C1.946 6.42145 1.946 6.07087 2.16233 5.85438L3.61666 4.39993L2.16225 2.94543C1.94592 2.7291 1.94592 2.37845 2.16225 2.16212C2.37854 1.94596 2.72897 1.94596 2.94535 2.16212L4.39999 3.61664L5.85453 2.16212C6.07094 1.94596 6.42142 1.94596 6.63767 2.16212C6.85408 2.37845 6.85408 2.7291 6.63775 2.94543Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchUnchecked);
export default __webpack_public_path__ + "static/media/switch-unchecked.ea71f5e4.svg";
export { ForwardRef as ReactComponent };